let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("hNRRw")).then(() => parcelRequire('cG9Gr'));